import React from 'react';
import {
	getSearchStringForBackNavigationWithBackText,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { Button, Row } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import WorkOrderTaskButton from '../work_order_task_button/WorkOrderTaskButton';
import WorkOrderCreateButton from '../common/WorkOrderCreateButton';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { SimpleRecordContainer } from '../simple_record_container/SimpleRecordContainer';
import { Link } from 'react-router-dom';
import WorkOrderRowDisplay from '../work_order_row_display/WorkOrderRowDisplay';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withUserType } from '../withUserType';
import { ImageRow } from '../image_row/ImageRow';
import { isWalkthroughNotesEnabled } from '../../utils/SiteSurveyUtils';
import { setLastViewedWalkthroughTask } from '../../utils/WalkthroughNavigationMemory';

const TaskAnswerDetails = ({ record, walkthrough, userType, location, history }) => {
	const photoStrings = (record.attachments || []).map((p) => {
		const fileName = nullSafeGetOrElse('fileName', p, '');
		const fileId = nullSafeGetOrElse('fileId', p, '');
		return `${fileId}/${fileName}`;
	});
	const workOrders = record.workOrders;
	const workOrderBackText = 'Back to Walkthrough';
	const getWorkOrderLink = (record) => {
		const searchString = getSearchStringForBackNavigationWithBackText(workOrderBackText, location);
		const backUrl = `/${userType}/workOrders/detail/${record.id}/details${
			!!searchString ? `?backlinkParams=${encodeURIComponent(searchString)}` : ''
		}`;
		return backUrl;
	};

	const handleSendNote = () => {
		const walkthroughId = nullSafeGet('id', walkthrough);
		const taskTitleId = nullSafeGet('titleId', record);
		// Remember the task so returning to the Overview lands the user back on it.
		setLastViewedWalkthroughTask(walkthroughId, taskTitleId);
		history.push(
			`/${userType}/siteSurveys/walkthrough/detail/${walkthroughId}/notes?siteSurveyTaskTitleId=${encodeURIComponent(
				taskTitleId
			)}`
		);
	};

	return (
		<div className={'taskAnswerDetails'}>
			{record.comments && record.comments.length > 0 ? (
				<Row>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: '1 1 50%',
							justifyContent: 'center',
							boxSizing: 'border-box',
							padding: '8px',
						}}
					>
						<div className="expanded_rowSubTitle">Comments</div>
						<div>{record.comments}</div>
					</div>
				</Row>
			) : null}
			<ImageRow photoStrings={photoStrings} />
			<Row style={{ width: '100%' }}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						boxSizing: 'border-box',
						padding: '8px',
						width: '100%',
					}}
				>
					<Row className="expanded_rowSubTitle justify-between">
						<span>Work Orders</span>
						<span>
							<Row>
								<WorkOrderTaskButton
									task={record}
									locationId={nullSafeGet('locationId', walkthrough)}
								/>
								{isWalkthroughNotesEnabled() ? (
									<Button
										size="middle"
										icon={<MessageOutlined />}
										onClick={handleSendNote}
										style={{ marginRight: 8 }}
									>
										Send Note
									</Button>
								) : null}
								<WorkOrderCreateButton
									align="center"
									size="middle"
									backText={'Back to Walkthrough'}
									title="Create Work Order"
									getLink={(location, BACK_TEXT, path) => {
										const taskIndex = walkthrough.taskAnswers.findIndex(
											(task) => task.titleId === record.titleId
										);
										const params = {
											locationId: walkthrough.locationId,
											images: (record.attachments || []).map(
												({ fileId, fileName }) => `${fileId}/${fileName}`
											),
											walkthroughId: walkthrough.id,
											siteSurveyTaskTitleId: record.titleId,
											walkthroughTaskIndex: taskIndex,
										};
										const paramsString = new URLSearchParams(params).toString();

										return getLinkWIthBackLinkParams(
											location,
											BACK_TEXT,
											`${path}?${paramsString}`
										);
									}}
								/>
							</Row>
						</span>
					</Row>
					{workOrders && workOrders.length > 0 ? (
						<SimpleRecordContainer
							items={workOrders.map((record) => (
								<Link
									to={getWorkOrderLink(record)}
									style={{
										display: 'flex',
										width: '100%',
										padding: '24px 16px',
										backgroundColor: 'white',
									}}
								>
									<WorkOrderRowDisplay workOrder={record} simpler={false} />
								</Link>
							))}
						/>
					) : (
						<div className="my-2">No work orders associated with this task</div>
					)}
				</div>
			</Row>
		</div>
	);
};
const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(TaskAnswerDetails))
);
